export function useLocationTracking() {}
